<template lang='pug'>
v-container
  v-progress-linear(v-if="loading" indeterminate, rounded, height="6")
  v-row(v-else)
    question-user-info(
      :can-manipulate="can_manipulate"
      v-model="questionUserInfoDrawer"
      :question="question"
    )

    v-col(v-if="!is_active" cols="12")
      v-alert(type="warning" text)
        router-link(to="/profile") Вам необходимо настроить почту для работы с заявками

    v-col(v-else cols="12")
      v-card(outlined)
        .d-flex.align-center
          v-list-item.mr-auto.px-0
            v-list-item-action.mx-2
              v-tooltip(bottom)
                template(v-slot:activator="{on}")
                  v-btn.rounded(@click="$router.go(-1)" color="secondary" fab tile small v-on="on")
                    v-icon mdi-chevron-left
                span Вернуться назад
            v-list-item-content
              v-list-item-title
                strong.mr-2 {{ cachedProject(question.project_id).name }}
          template(v-if="!is_child()")
            v-btn.mr-2( color="success" @click="groupClose") Закрыть
            v-btn.mr-8.rounded(
              @click="deleteQuestionsDialog = true"
              color="error"
              small
              tile
              height="36px"
            ) Удалить
          v-tooltip(bottom)
            template(v-slot:activator="{on}")
              v-btn.rounded.mr-2(color="secondary" @click="questionUserInfoDrawer = true" fab tile small v-on="on")
                v-icon mdi-information-outline
            span Дополнительная инфомармация
        v-divider
        .pa-2.d-flex.align-center
          div.text-h6.mr-auto(v-html="question.text")
        .d-flex.flex-wrap.mb-2
          Element(
            canDownload
            v-for="(image, index) in [...question.images, ...question.documents]"
            :key="index"
            :url="image.url"
            :name="image.original_name || image.name"
          )

        v-divider
        .pa-2(v-html="question.full_text")
        v-row.ma-0
          .d(v-if="can_manipulate")

            template(v-if="question.status===CLIENT_QUESTION_STATUS.ACCEPTED \
                          || question.status===CLIENT_QUESTION_STATUS.ANSWERED"
            )
              check-list(:question-id="question.id")
              v-divider
            v-row.ma-0.pa-4
              v-btn.success.mr-4(
                v-if="is_child() || is_parent"
                @click="takeQuestionSelf"
              ) Забрать себе
              AppointDialog(v-if="is_parent" :users="users")
            .pa-2.question-actions
              template-modal(@select="form.text += $event" :question="question")
                template(#activator="{ on }")
                  v-tooltip(bottom) Выбор шаблона для быстрого ответа
                    template(#activator="{ on:tooltip }")
                      v-btn(
                        outlined
                        v-on="{...on, ...tooltip}"
                      )
                        v-icon mdi-clipboard-check-multiple-outline

              v-tooltip(bottom) Сохранить шаблон
                template(v-slot:activator="{ on:tooltip }")
                  v-btn(outlined @click="createTemplateDialog = !createTemplateDialog" v-on="tooltip")
                    v-icon mdi-content-save
              v-tooltip(bottom) Ответить всем
                template(v-slot:activator="{on}")
                  v-btn(
                    v-on="on"
                    v-if="question.status === CLIENT_QUESTION_STATUS.PENDING"
                    @click="is_show_questions = !is_show_questions"
                    outlined
                  )
                    v-icon mdi-message-text-outline
                    v-icon {{ is_show_questions ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

              template(v-if="question.status === CLIENT_QUESTION_STATUS.PENDING && !this.chat")
                v-btn(
                  color="success"
                  @click="acceptApplication"
                  :loading="loadingAccept"
                ) Принять в работу
              template(v-if="question.status === CLIENT_QUESTION_STATUS.CLOSED")
                v-btn(
                  color="success"
                  @click="reopenApp"
                ) Открыть задачу
              v-tooltip(bottom) Закрыть заявку
                template(#activator="{ on }")
                  v-btn(
                    v-on="on"
                    :loading="closingLoading"
                    v-if="question.status === CLIENT_QUESTION_STATUS.ANSWERED"
                    color="error"
                    @click="closeQuestionDialog = true"
                  )
                    v-icon mdi-close-thick
          v-spacer
          v-btn.mt-10.mr-2(color="error" @click="startAnalyzeText") Анализировать
        template(v-if="(messages || []).length")
          v-divider
          application-chat(:messages="messages" @intersect="onIntersect")
          v-expand-transition
            div(v-if="is_show_questions" key="showed")
              v-divider.pt-2
              smart-table(
                v-model="selected"
                :adapter="adapter"
                :headers="headers"
                show-select
              )
                template(#header)
                  v-btn(@click="is_show_questions = false" outlined) Отменить
                template(#value--municipality_id="{ item }")
                  v-chip(
                    v-if="item.municipality_id"
                    text
                    label
                  ) {{ item.municipality_id }}
                  v-chip(v-else text label) Не указано
                template(#value--view="{ item }")
                  router-link(:to="`/application/${item.id}`")
                    v-icon(color="primary" small) mdi-eye

        .px-2.mb-2.pt-4
          app-editor(v-model="form.text" placeholder="Ваш ответ на обращение" filled outlined)

          v-divider
          .pa-2.d-flex(style="overflow-x:auto")
            uploader(@upload="form.files.push($event)")
              template(#activator)
                v-btn.mr-4(color="success" height="120px" width="120px")
                  .d-flex.flex-column
                    v-icon mdi-plus
                    span.caption Добавить файл
            Element(
              v-for="(file, index) in form.files"
              :key="index"
              show-actions
              :name="file.original_name"
              :url="file.url"
              @delete="form.files.splice(index, 1)"
            )
          template(v-if="can_answer")
            v-divider
            .pa-2
              v-btn.mr-2(
                :disabled="(form.text || '').length < 10"
                :loading="loadingMessage"
                color="success"
                @click="sendMessage()"
              ) Ответить {{ selected.length || '' }}

              select-instruction(:projectId="question.project_id" @get-pdf="addInscruction($event)")

          template(v-if="question.status === CLIENT_QUESTION_STATUS.CLOSED")
            v-alert(type="error" tile).mb-0 Заявка была закрыта
          template(v-if="question.status === CLIENT_QUESTION_STATUS.DELETED")
            v-alert(type="error" tile).mb-0 Заявка была удалена
      v-btn.success.mt-2.ml-3(
        v-if="can_take"
        @click="takeQuestion"
      ) Забрать себе
      transfer(
        v-if="(question.transfers || []).length"
        :question="question"
      )
    confirm-form-dialog(
      message="Действительно закрыть заявку?"
      v-model="closeQuestionDialog"
      @accept="closeQuestion"
    )
    confirm-form-dialog(
      v-model="deleteQuestionsDialog"
      @accept="acceptDeleteQuestions"
      :message="`Действильно хотите удалить?`"
    )
    create-question-template(
      :edit-data="{ text: form.text,project_id: question.project_id }"
      :value="createTemplateDialog"
    )

    v-dialog(v-model="analyzeDialog" width="1000")
      v-card(dark max-height='60vh' )
        v-list-item
          v-list-item-title.title Результаты анализа текста сообщения
          v-list-item-action
            v-btn(color="white" icon @click="analyzeDialog = false")
              v-icon mdi-close
        v-card-text
          v-list(color="transparent" dark)
            v-list-item(v-for="item in analyzeResult")
              v-list-item-content
                v-list-item-title {{ item.title }}?
                div Ключевые слова:
                  v-chip-group
                    v-chip(small v-for="word in item.words") {{ word }}
                span Oтвет:
                p {{ item.text }}
        v-card-action
</template>

<script>
import { ROLES } from '@/constants';
import  checkRole  from '@/lib/checkRole';
import transferServices from '@/services/API/transfer';
import emailSettingsService from '@/services/API/email-settings';
import ApplicationChat from '../../components/ApplicationChat.vue';
import AppEditor from '@/components/AppEditor.vue';
import TemplateModal from '../../components/TemplateModal.vue';
import { mapActions, mapGetters } from 'vuex';
import { isImage } from '@/lib/index';
import clientQuestionsService from '@/services/API/client-questions';
import CreateQuestionTemplate from '@/components/dialogs/CreateQuestionTemplate.vue';
import { CRUDChatMessages } from '@/services/API/_crud';
import  { CRUDChat } from '@/services/API/chat';
import Element from '@/components/icons/Element.vue';
import Uploader from '@/components/core/Uploader.vue';
import { CLIENT_QUESTION_STATUS } from '../../constants';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import SimularApplications from './components/SimularApplications.vue';
import QuestionUserInfo from './components/QuestionUserInfo.vue';
import { CACHE_KEYS } from '@/store/modules/cache';
import CheckList from './components/CheckList.vue';
import Transfer from './components/Transfer.vue';
import SmartTable from '@/components/SmartTable/index.vue';
import SelectInstruction from '@/components/dialogs/SelectInstruction.vue';
import { NOTIFICATION_TYPES } from '@/store/modules/notification';
import AppointDialog from './components/AppointDialog.vue';
import userService from '@/services/API/user';

const DEFAULT_FORM  = {
  text:'',
  files: [],
};

export default {
  components:{
    SelectInstruction,
    ApplicationChat,
    AppEditor,
    TemplateModal,
    CreateQuestionTemplate,
    Element,
    Uploader,
    ConfirmFormDialog,
    SimularApplications,
    QuestionUserInfo,
    CheckList,
    Transfer,
    SmartTable,
    AppointDialog,
  },
  data() {
    return {
      page: 1,
      totalPages: null,
      analyzeDialog: false,
      analyzeResult: [],
      deleteQuestionsDialog: false,
      createTemplateDialog: false,
      is_active: false,
      tooltipStatus: false,
      show_checklist:false,
      addInscructionDialog: false,
      questionUserInfoDrawer: false,
      form: { ...DEFAULT_FORM },
      loadingMessage: false,

      closeQuestionDialog:false,

      loading: false,
      closingLoading:false,

      question: null,
      loadingAccept: false,

      chat: null,
      messages:[],
      users: [],

      // answer all
      selected: [],
      is_show_questions: false,
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Номер заявки',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Дата заявки',
          value: 'created_at',
        },
        {
          text: 'Причина обращения',
          value: 'text',
        },
        {
          text: 'Почта отправителя',
          sortable: true,
          value: 'email',
        },
      ],

      CLIENT_QUESTION_STATUS,
    };
  },
  computed:{
    ...mapGetters({
      'user':'auth/getUser',
      'cachedProject': 'cache/cachedProject',
      'notification': 'notification/notification',
      'cachedUser': 'cache/cachedUser',
    }),
    is_parent() {
      if (this.user.parent_id) {
        const user = this.users.some((item) => this.question.worker_id === item.id);
        return user;
      }
      return false;
    },
    can_manipulate() {
      const { worker_id } = this.question;
      if (this.question.current_transfer) return this.question.current_transfer.worker_id === this.user.id;
      if (worker_id) return this.user.id === worker_id || this.is_child();
      return false;
    },
    can_take() {
      // Не можем забрать у себя(!can_manipulate)
      // У мун могут забрать - Саппорт, Регион
      // У Региона - саппорт, а у саппорта нельзя забрать.
      const { roles } = this.user;
      const workerRole = this.cachedUser(this.question.worker_id).roles;
      if (this.question.worker_id === this.user.id) return false;
      if (checkRole(workerRole, ROLES.municipality) && (checkRole(roles, ROLES.region) || checkRole(roles, ROLES.support))) {
        return true;
      }
      if (checkRole(workerRole, ROLES.region) && checkRole(roles, ROLES.support)) return true;
      return false;
    },
    can_answer() {
      return [
        CLIENT_QUESTION_STATUS.ACCEPTED,
        CLIENT_QUESTION_STATUS.ANSWERED,
        CLIENT_QUESTION_STATUS.PENDING,
        CLIENT_QUESTION_STATUS.AWAITING,
      ].includes(this.question.status);
    },
  },
  watch:{
    is_show_questions(v) {
      if (!v) this.selected = [];
    },
    page(v) {
      if (v <= this.totalPages) this.fetchMessages();
    },
    notification:{
      async handler(v) {
        const { id, chat_id } = v.data;
        if (
          v.type === NOTIFICATION_TYPES.CHAT_MESSAGE && chat_id === this.chat.id
        ) {
          const response = await CRUDChatMessages.get(id, { 'expand':'images,documents' });
          this.messages.push(response.data.data);
        }
      },
    },
  },
  beforeDestroy() {
    this.form.files = [];
    DEFAULT_FORM.files = [];
  },

  created() {
    this.init();
  },
  methods:{
    ...mapActions({
      'loadToCache': 'cache/loadToCache',
    }),
    onIntersect() {
      this.page += 1;
    },
    async startAnalyzeText() {
      const params = {
        text: this.question.full_text,
        project_id: this.question.project_id,
      };
      const response = await clientQuestionsService.AnalyzeText(params);
      if (response.data.data.length > 0) {
        this.analyzeResult = response.data.data;
        this.analyzeDialog = true;
      } else {
        this.$toast.error('Для данного вопроса не нашлось ни одного автоответа');
      }
    },
    async acceptDeleteQuestions() {
      const params = {
        client_question_ids: [this.$route.params.id],
      };
      await clientQuestionsService.destroy(params);
      this.$router.go(-1);
      this.deleteQuestionsDialog = false;
    },
    async groupClose() {
      try {
        const params = {
          'client_question_ids': [this.$route.params.id],
        };
        await clientQuestionsService.close(params);
        this.init();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async init() {
      this.loading = true;

      await this.fetchClientQuestion();
      await this.fetchChat();
      await this.getUsers();
      await this.getUserIsActive();

      if (this.chat) {
        await this.fetchMessages();
      }

      this.loading = false;
    },
    async getUserIsActive() {
      if (this.user.email_setting) {
        const { id } = this.user.email_setting;
        const response = await emailSettingsService.get(id);
        this.is_active = response.data.data.is_active || true;
      } else {
        this.is_active = false;
      }
    },
    is_child() {
      if (!this.user.parent_id) return false;
      return this.user.parent_id === this.question.worker_id;
    },
    async takeQuestionSelf() {
      try {
        await clientQuestionsService.take(this.question.id);
        this.$toast.success('Вы успешно забрали себе эту заявку');
        this.init();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async takeQuestion() {
      const params = {
        'client_question_id' : this.question.id,
      };
      try {
        await transferServices.takeQuestion(params);
        this.$toast.success('Вы успешно забрали себе эту заявку');
        this.$router.push('/inbox');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    adapter(options) {
      const params = {
        'per-page': options.itemsPerPage,
        'sort': '-id',
        'search[project_id]': this.projectId,
        'search[question_category_id]': this.questionCategoryId,
        'search[status]': [1, 2, 3],
        ...options,
      };
      return clientQuestionsService.getAll(params);
    },
    addInscruction(instruction) {
      this.form.text = `${this.form.text} \n <a href="${instruction.pdf_url}" target="_blank">${instruction.name}</a>`;
      this.$toast.success('Вы успешно добавили инструкцию');
    },

    async fetchClientQuestion() {
      const params = {
        expand: 'images,documents,transfers,current_transfer,worker',
      };

      try {
        const response = await clientQuestionsService.get(this.$route.params.id, params);
        await this.loadToCache({ key: CACHE_KEYS.users, ids: [response.data.data.worker_id] });
        await this.loadToCache({ key: CACHE_KEYS.projects, ids: [response.data.data.project_id] });
        await this.loadToCache({ key: CACHE_KEYS.question_categories, ids: [response.data.data.question_category_id] });
        this.question = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    async getUsers() {
      const response = await userService.publicUsers({ 'search[parent_id]': this.user.id });
      this.users = response.data.data;
    },
    async fetchChat() {
      const params = {
        'search[client_question_id]': this.question.id,
      };

      try {
        const response = await CRUDChat.getAll(params);
        const [chat] = response.data.data;
        this.chat = chat;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async fetchMessages() {
      const params = {
        'search[chat_id]': this.chat.id,
        'expand':'images,documents',
        'sort': 'send_at',
        'page': this.page,
      };

      try {
        const response = await CRUDChatMessages.getAll(params);
        this.totalPages = +response.headers['x-pagination-page-count'];
        this.messages.push(...response.data.data);
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async acceptApplication() {
      this.loadingAccept = true;

      const params = { 'client_question_id': this.question.id };

      try {
        const response = await CRUDChat.create(params);
        await clientQuestionsService.take(this.question.id);
        this.chat = response.data.data;
        this.takeQuestionSelf();
        this.question.status = CLIENT_QUESTION_STATUS.ACCEPTED;

        this.fetchMessages();
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      } finally {
        this.loadingAccept = false;
      }
    },
    async reopenApp() {
      try {
        clientQuestionsService.updateStatus(this.question.id, 1);
        this.$toast.success('Вы успешно открыли задачу');
        this.$router.push('/inbox');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async sendMessage() {
      if (this.is_child()) await clientQuestionsService.take(this.question.id);
      const images =  this.form.files.filter(({ file_name }) => isImage(file_name));
      const documents = this.form.files.filter(({ file_name }) => !isImage(file_name));

      const params = {
        images: images.map(({ file_name }) => file_name),
        documents: documents.map(({ file_name }) => file_name),
        text: this.form.text,
      };

      this.loadingMessage = true;

      const question_ids = [...this.selected, this.question.id];

      try {
        if (this.chat) {
          params.chat_id = this.chat.id;
          const response = await CRUDChatMessages.create(params);
          this.messages.push({ ...response.data.data, images, documents });
          this.$toast.success('Сообщение отправлено');
        } else {
          delete params.chat;
          const ids = new Set(question_ids);
          params.client_question_ids = Array.from(ids);
          await clientQuestionsService.answer(params);

          this.init();

          this.$toast.success('Ответы были отправлены');
        }

        this.question.status = CLIENT_QUESTION_STATUS.ANSWERED;

        this.form = { ...DEFAULT_FORM };
        this.form.files = [];
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      } finally {
        this.loadingMessage = false;
        this.selected = [];
      }
    },

    async closeQuestion() {
      this.closingLoading = true;
      try {
        const params = { 'client_question_ids': [this.question.id] };
        await clientQuestionsService.close(params);
        this.question.status = CLIENT_QUESTION_STATUS.CLOSED;
      } catch (error) {
        this.$toast.error(error.response.data.data.result_message);
      } finally {
        this.closingLoading = false;
      }
    },

  },
};
</script>

<style lang="scss">
.question-actions {
  .v-btn {
    border-radius: 0px;
    border:2px solid #e0e0e0;

    &:last-child{
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &:first-child{
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
}
</style>
